import axiosInstance from '@/api/axiosInstance';
import { FetchReportDataRequest, FetchReportDataResponse } from './types';

export const fetchReportData = async (
  request: FetchReportDataRequest
): Promise<FetchReportDataResponse> => {
  const { reportType, filters, page = 1, pageSize = 20, sortBy, sortOrder } = request;

  const params = {
    ...filters,
    page,
    pageSize,
    sortBy,
    sortOrder,
  };

  const response = await axiosInstance.get<FetchReportDataResponse>(
    `/api/private/reports/${reportType}`,
    { params }
  );

  return response.data;
};
